export const DefaultBreadcrumbProps = {
  links: []
};